export enum AccountViewTab {
  Overview = 'overview',
  AdvancedDetails = 'advanced-details',
  Kyc = 'kyc',
  Activity = 'activity',
  FraudReferral = 'fraud-referral',
  FileAttachments = 'file-attachments',
  Payments = 'payments',
  AtoAutomation = 'ato-automation'
}

const ACCOUNT_VIEW_BASE_PATH = '/sherlock/account-view';

export const buildAccountViewTabPath = (
  organizationId: number | string,
  tab: AccountViewTab
): string => `${ACCOUNT_VIEW_BASE_PATH}/${organizationId}/${tab}`;
